//! IMPORT ZONE
import { Outlet } from "react-router";
import Navbar from "./Navbar/Navbar";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useContext } from "react";
import { CustomThemesContext } from "./Providers/CustomThemesProvider";

const App = () => {
  const { appliedTheme } = useContext(CustomThemesContext);

  return (
    // TODO investigate if this could/should go in injex.js
    // we wrap app.js in ThemeProvider, a prebuilt provider imported from MUI, to inject theming into our app
    // it takes a "theme" prop -- we've given it the custom theme built in DarkModeProvider,which can rebuild itself on the fly if the user changes to dark mode
    <ThemeProvider theme={appliedTheme}>
      <CssBaseline />
      <Navbar />
      <Outlet />
    </ThemeProvider>
  );
};
export default App;
